<!-- Hero Section -->
<section class="products-hero">
    <div class="hero-content">
        <h1 class="hero-headline">Explore Our Complete Classroom Digitization Ecosystem</h1>
        <p class="hero-subtext">
            Smart Panels, IFP Protection (Shutter), All-in-One PCs, LMS, K-12 Content & Digital E-Library for modern
            learning.
        </p>
    </div>
</section>

<!-- Solutions Grid Section -->
<section class="solutions-section">
    <div class="container">
        <div class="section-header text-center mb-5">
            <h2 class="section-title">Explore <span>Solutions</span></h2>
            <div class="title-underline"></div>
        </div>

        <div class="solutions-grid">
            <div class="solution-card" *ngFor="let solution of solutions">
                <div class="solution-image-wrapper">
                    <img [src]="solution.image" [alt]="solution.title" class="solution-img">
                </div>
                <div class="card-content">
                    <h3 class="solution-title">{{ solution.title }}</h3>
                    <p class="solution-description">{{ solution.description }}</p>
                    <a [routerLink]="solution.link" class="view-solution-btn">
                        <span>View Solution</span>
                        <mat-icon>arrow_forward</mat-icon>
                    </a>
                </div>
                <div class="card-gradient"></div>
            </div>
        </div>
    </div>
</section>